import drawLabelFAC from './drawLabelFAC'
import mergeColLabels from './mergeColLabels'
import mergeRowLabels from './mergeRowLabels'

const makeImageLabels = async (labelsData, width = 460, height = 170, totalCols = 1) => {
    const drawLabelsPromise = Array.isArray(labelsData) ? labelsData.map(labelData => {
        const data = Object.assign({}, labelData, {
            orderId: '#' + labelData.orderId
        })
        return drawLabelFAC(data)
    }) : []

    const labels = await Promise.all(drawLabelsPromise)

    const rowLabels = []

    // nếu totalCols > 1 thì mới ghép 2 cột (merge cặp left-right)
    if (Number(totalCols) > 1) {
        for (let i = 0; i < labels.length; i += 2) {
            const left = labels[i]
            const right = labels[i + 1]

            if (right) {
                // khi có cặp, merge 2 cột
                const rowLabel = await mergeColLabels(left, right, width, height, totalCols)
                rowLabels.push(rowLabel)
            } else {
                // nếu lẻ (không có right), giữ left như một row
                rowLabels.push(left)
            }
        }
    } else {
        // totalCols <= 1: không ghép cột, mỗi label là một row
        rowLabels.push(...labels)
    }

    const labelImages = await mergeRowLabels(rowLabels, width, height)

    return labelImages
}

export default makeImageLabels
